export const TRANSACTION_ATTACHMENT_MAX_TOTAL_SIZE = 9.5 * 1024 * 1024;
